import React, { createContext, useContext, useState } from 'react';

const GlobalUploadContext = createContext();

export const GlobalUploadProvider = ({ children }) => {
    const [files, setFiles] = useState([]); // [{ file, status, error, progress }]
    const [status, setStatus] = useState('initialization');
    const [uploadState, setUploadState] = useState([]);
    const [uploadQueue, setUploadQueue] = useState({ waiting: [], completed: [] });

    return (
        <GlobalUploadContext.Provider
            value={{ files, setFiles, status, setStatus, uploadState, setUploadState, uploadQueue, setUploadQueue }}>
            {children}
        </GlobalUploadContext.Provider>
    );
};

export const useGlobalUpload = () => useContext(GlobalUploadContext);
